import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { lazyWithRetry } from "@/utils/common/lazyWithRetry";
import PrivateLayout from "./Layouts/private/PrivateLayout";
import MagicLink from "./pages/MagicLink/MagicLink";
import { routesList } from "./routesList";

const HomeView = lazyWithRetry(() => import("./pages/Home/HomeView"));

const LoginView = lazyWithRetry(() => import("./pages/Login/LoginView"));
const LogoutView = lazyWithRetry(() => import("./pages/Logout/LogoutView"));
const RepairView = lazyWithRetry(() => import("./pages/Repair/RepairView"));
const RegisterView = lazyWithRetry(() => import("./pages/Register/RegisterView"));

const PrivacyView = lazyWithRetry(() => import("./pages/Legal/PrivacyView"));
const CookiesView = lazyWithRetry(() => import("./pages/Legal/CookiesView"));
const TermsView = lazyWithRetry(() => import("./pages/Legal/TermsView"));

const CrewInvitation = lazyWithRetry(() => import("./pages/CrewInvitation/CrewInvitationView"));
const ItemsView = lazyWithRetry(() => import("./pages/Items/ItemsView"));
const MementosView = lazyWithRetry(() => import("./pages/Mementos/MementosView"));
const TasksDashboard = lazyWithRetry(
	() => import("./pages/Mementos/TasksDashboard/TasksDashboard"),
);

const EconomosHomeView = lazyWithRetry(
	() => import("./pages/Economos/Dashboard/EconomosMovementsDashboard"),
);
const EconomosMovementsView = lazyWithRetry(
	() => import("./pages/Economos/Movements/EconomosMovementsView"),
);
const EconomosSearchView = lazyWithRetry(
	() => import("./pages/Economos/Search/EconomosSearchView"),
);

const OnboardingGroup = lazyWithRetry(() => import("./pages/Onboarding/GroupView"));
const Settings = lazyWithRetry(() => import("./pages/Settings/Settings"));
const UsageView = lazyWithRetry(() => import("./pages/Usage/UsageView"));

const DashboardView = lazyWithRetry(() => import("./pages/Dashboard/DashboardView"));

const SplitExpensesView = lazyWithRetry(() => import("./pages/SplitExpenses/SplitExpensesView"));
const SplitExpensesGroupView = lazyWithRetry(
	() => import("./pages/SplitExpenses/SplitExpensesGroupView"),
);

const RecipesView = lazyWithRetry(() => import("./pages/Recipes/RecipesView"));
const RecipeDetail = lazyWithRetry(() => import("./pages/Recipes/RecipeDetail"));
const RecipeShareView = lazyWithRetry(() => import("./pages/Recipes/RecipeShareView"));

export function RoutesGroup() {
	return (
		<Routes>
			{/* ********************************** */}
			{/* Public routes */}
			{/* ********************************** */}
			<Route
			// element={<WebHeader><Outlet /></WebHeader>}
			>
				<Route path={routesList.home.path} element={<HomeView />} />

				<Route path={routesList.login.path} element={<LoginView />} />
				<Route path={routesList.logout.path} element={<LogoutView />} />
				<Route path={routesList.repair.path} element={<RepairView />} />
				<Route path={routesList.magicLink.path} element={<MagicLink />} />

				<Route path={routesList.register.path} element={<RegisterView />} />

				<Route path={routesList.legalPrivacy.path} element={<PrivacyView />} />
				<Route path={routesList.legalCookies.path} element={<CookiesView />} />
				<Route path={routesList.legalTerms.path} element={<TermsView />} />
			</Route>

			{/* ********************************** */}
			{/* Layoutless routes */}
			{/* ********************************** */}

			<Route path={routesList.crewInvitation.path} element={<CrewInvitation />} />
			<Route path={routesList.recipeShare.path} element={<RecipeShareView />} />

			{/* ********************************** */}
			{/* Private routes */}
			{/* ********************************** */}

			<Route
				element={
					<PrivateLayout>
						<Outlet />
					</PrivateLayout>
				}
			>
				<Route path={routesList.dashboard.path} element={<DashboardView />} />

				<Route path="/eidos" element={<Navigate to={routesList.items.path} replace />} />
				<Route path={routesList.items.path} element={<ItemsView />} />
				<Route path={routesList.tasks.path} element={<TasksDashboard />} />
				<Route path={routesList.tasksList.path} element={<MementosView />} />

				<Route path={routesList.money.path} element={<EconomosHomeView />} />
				<Route path={routesList.moneyMovements.path} element={<EconomosMovementsView />} />
				<Route path={routesList.moneySearch.path} element={<EconomosSearchView />} />

				<Route path={routesList.onboardingGroup.path} element={<OnboardingGroup />} />

				<Route path={routesList.settings.path} element={<Settings />} />
				<Route path={routesList.usage.path} element={<UsageView />} />

				<Route path={routesList.split.path} element={<SplitExpensesGroupView />} />
				<Route path={routesList.splitGroup.path} element={<SplitExpensesView />} />

				<Route path={routesList.recipes.path} element={<RecipesView />} />
				<Route path={routesList.recipeDetail.path} element={<RecipeDetail />} />
			</Route>

			<Route path="*" element={<Navigate to={routesList.dashboard.path} replace />} />
		</Routes>
	);
}
